.grid {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

.typeList {
  overflow: auto;
  height: 100%;
}

.commandList {
  overflow: auto;
  height: 100%;
}
